import { SkinnableComponent, ComponentSkinProps } from '../../../types/component-skin';
import { COMPONENT_TYPES } from '../../../constants';
import { useImageSliderLogic } from './ImageSliderLogic';
import BasicImageSliderSkin from './skins/BasicImageSliderSkin';

/**
 * ImageSlider 컴포넌트의 스킨 시스템 정의
 */
export const ImageSliderSkinnable: SkinnableComponent = {
  type: COMPONENT_TYPES.IMAGE_SLIDER,
  name: '이미지 슬라이더',
  category: 'media',
  icon: '🖼️',
  options: [
    {
      type: 'text',
      label: '슬라이더 제목',
      key: 'sliderTitle',
      default: '이미지 슬라이더'
    },
    {
      type: 'checkbox',
      label: '제목 표시',
      key: 'showTitle',
      default: false
    },
    {
      type: 'text',
      label: '제목 폰트 크기',
      key: 'titleFontSize',
      default: '24px'
    },
    {
      type: 'text',
      label: '제목 폰트 무게',
      key: 'titleFontWeight',
      default: '600'
    },
    {
      type: 'color',
      label: '제목 색상',
      key: 'titleColor',
      default: '#333'
    },
    {
      type: 'text',
      label: '슬라이더 높이',
      key: 'sliderHeight',
      default: '400px'
    },
    {
      type: 'number',
      label: '표시할 이미지 수',
      key: 'slidesToShow',
      default: 1,
      min: 1,
      max: 5
    },
    {
      type: 'checkbox',
      label: '자동 슬라이드',
      key: 'autoSlide',
      default: true
    },
    {
      type: 'number',
      label: '자동 슬라이드 간격 (ms)',
      key: 'autoSlideInterval',
      default: 4000,
      min: 1000,
      max: 10000
    },
    {
      type: 'checkbox',
      label: '무한 슬라이드',
      key: 'infiniteSlide',
      default: true
    },
    {
      type: 'checkbox',
      label: '네비게이션 표시',
      key: 'showNavigation',
      default: true
    },
    {
      type: 'checkbox',
      label: '인디케이터 표시',
      key: 'showIndicators',
      default: true
    },
    {
      type: 'select',
      label: '이미지 맞춤',
      key: 'imageObjectFit',
      options: [
        { value: 'cover', label: 'Cover' },
        { value: 'contain', label: 'Contain' },
        { value: 'fill', label: 'Fill' },
        { value: 'none', label: 'None' },
        { value: 'scale-down', label: 'Scale Down' }
      ],
      default: 'cover'
    }
  ],
  defaultSkin: 'basic',
  internalSkins: {
    basic: BasicImageSliderSkin as any
  },
  useLogic: useImageSliderLogic as any,
  defaultProps: {
    sliderTitle: '이미지 슬라이더',
    showTitle: false,
    titleFontSize: '24px',
    titleFontWeight: '600',
    titleColor: '#333',
    sliderHeight: '400px',
    slidesToShow: 1,
    autoSlide: true,
    autoSlideInterval: 4000,
    infiniteSlide: true,
    showNavigation: true,
    showIndicators: true,
    imageObjectFit: 'cover',
    images: [
      {
        id: '1',
        url: 'https://via.placeholder.com/800x400/3498db/ffffff?text=Slide+1',
        title: '첫 번째 슬라이드',
        alt: '슬라이드 1',
        link: '',
        openInNewTab: false
      },
      {
        id: '2',
        url: 'https://via.placeholder.com/800x400/e74c3c/ffffff?text=Slide+2',
        title: '두 번째 슬라이드',
        alt: '슬라이드 2',
        link: '',
        openInNewTab: false
      },
      {
        id: '3',
        url: 'https://via.placeholder.com/800x400/2ecc71/ffffff?text=Slide+3',
        title: '세 번째 슬라이드',
        alt: '슬라이드 3',
        link: '',
        openInNewTab: false
      }
    ]
  }
};